import { OutlinedInput } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useCallback, useRef, useState } from "react";
import { ChromePicker } from "react-color";
import { IProductParams, PLATFORM_TYPE_TV } from "../../../model";
import { appLogger } from "../../../utils";
import useClickOutside from "./useClickOutside";

const BrandingCommonForm = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "WidgetPreview",
      component: "add-product",
      fileName: "WidgetPreview.tsx",
      prpos: props,
    },
  });

  const {
    productParams,
    setProductParams,
    field,
    textColor,
    fontFamily,
    fontStyle,
    fontSize,
    fontWeight,
  } = props;
  const [ismainTitleClrPalletOpen, setmainTitleClrPalletOpen] = useState(false);
  // const [mainTitleClr, setmainTitleClr] = useState<any>("#040000");
  const mainTitileClrPopover = useRef<any>(null);
  const mainTitleclrpalleteclose = useCallback(
    () => setmainTitleClrPalletOpen(false),
    []
  );
  useClickOutside(mainTitileClrPopover, mainTitleclrpalleteclose);

  const handleTextColorChange = (event: any) => {
    const textClr = event;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-title"
          ] = textClr;
          setProductParams(temp);
        } else if (field == "sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-subtitle"
          ] = textClr;
          setProductParams(temp);
        } else if (field == "card-main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-title"
          ] = textClr;
          setProductParams(temp);
        } else if (field == "card-sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-subtitle"
          ] = textClr;
          setProductParams(temp);
        } else if (field == "primary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary-button-text-color"
          ] = textClr;
          setProductParams(temp);
        } else if (field == "secondary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary-button-text-color"
          ] = textClr;
          setProductParams(temp);
        } else if (field == "input-label") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-label-color"
          ] = textClr;
          setProductParams(temp);
        } else if (field == "attachment-helper") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-attachment-helper-color"
          ] = textClr;
          setProductParams(temp);
        }
      }
    }
  };

  const handleFontFamilyChange = (event: any) => {
    const fontFamily = event.target.value;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-title-font-family"
          ] = fontFamily;
          setProductParams(temp);
        } else if (field == "sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-subtitle-font-family"
          ] = fontFamily;
          setProductParams(temp);
        } else if (field == "card-main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-title-font-family"
          ] = fontFamily;
          setProductParams(temp);
        } else if (field == "card-sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-subtitle-font-family"
          ] = fontFamily;
          setProductParams(temp);
        } else if (field == "primary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary-button-text-font-family"
          ] = fontFamily;
          setProductParams(temp);
        } else if (field == "secondary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary-button-text-font-family"
          ] = fontFamily;
          setProductParams(temp);
        } else if (field == "input-label") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-label-font-family"
          ] = fontFamily;
          setProductParams(temp);
        } else if (field == "attachment-helper") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-attachment-helper-font-family"
          ] = fontFamily;
          setProductParams(temp);
        }
      }
    }
  };

  const handleFontWeight = (event: any) => {
    const fontWeight = event.target.value;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-title-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        } else if (field == "sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-subtitle-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        } else if (field == "card-main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-title-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        } else if (field == "card-sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-subtitle-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        } else if (field == "primary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary-button-text-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        } else if (field == "secondary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary-button-text-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        } else if (field == "input-label") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-label-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        } else if (field == "attachment-helper") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-attachment-helper-font-weight"
          ] = fontWeight;
          setProductParams(temp);
        }
      }
    }
  };

  const handleFontStyle = (event: any) => {
    const fontStyle = event.target.value;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-title-font-style"
          ] = fontStyle;
          setProductParams(temp);
        } else if (field == "sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-subtitle-font-style"
          ] = fontStyle;
          setProductParams(temp);
        } else if (field == "card-main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-title-font-style"
          ] = fontStyle;
          setProductParams(temp);
        } else if (field == "card-sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-subtitle-font-style"
          ] = fontStyle;
          setProductParams(temp);
        } else if (field == "primary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary-button-text-font-style"
          ] = fontStyle;
          setProductParams(temp);
        } else if (field == "secondary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary-button-text-font-style"
          ] = fontStyle;
          setProductParams(temp);
        } else if (field == "input-label") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-label-font-style"
          ] = fontStyle;
          setProductParams(temp);
        } else if (field == "attachment-helper") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-attachment-helper-font-style"
          ] = fontStyle;
          setProductParams(temp);
        }
      }
    }
  };

  const handleFontSize = (event: any) => {
    let fontSize = event.target.value;
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].technology == "rokuTv"
    ) {
      fontSize =
        typeof fontSize == "string" ? fontSize.replace("px", "") : fontSize;
    }

    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-title-font-size"
          ] = fontSize;
          setProductParams(temp);
        } else if (field == "sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-main-subtitle-font-size"
          ] = fontSize;
          setProductParams(temp);
        } else if (field == "card-main-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-title-font-size"
          ] = fontSize;
          setProductParams(temp);
        } else if (field == "card-sub-title") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-popup-dialog-card-subtitle-font-size"
          ] = fontSize;
          setProductParams(temp);
        } else if (field == "primary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary-button-text-font-size"
          ] = fontSize;
          setProductParams(temp);
        } else if (field == "secondary-button") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary-button-text-font-size"
          ] = fontSize;
          setProductParams(temp);
        } else if (field == "input-label") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-label-font-size"
          ] = fontSize;
          setProductParams(temp);
        } else if (field == "attachment-helper") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-attachment-helper-font-size"
          ] = fontSize;
          setProductParams(temp);
        }
      }
    }
  };

  return (
    <>
      {/* ******************Form Appreance******************************** */}

      <Grid container spacing={2} className="form-appearance-section">
        <Grid item xs={12} sm={3}>
          <div className="mainAgentpickerColorDiv">
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={1} sx={{ marginTop: 0 }}>
                <Grid xs={2}>
                  <div
                    className="swatch"
                    style={{ backgroundColor: textColor }}
                    onClick={() => setmainTitleClrPalletOpen(true)}
                  />
                </Grid>
                <Grid xs={10}>
                  <div>
                    <FormControl className="custom-select" fullWidth>
                      <InputLabel>Text Color </InputLabel>
                      <OutlinedInput
                        type="text"
                        value={textColor}
                        label="Button Color"
                        onChange={(event) => {
                          handleTextColorChange(event.target.value);
                        }}
                        onFocus={(event) => {
                          setmainTitleClrPalletOpen(true);
                        }}
                      />
                    </FormControl>
                  </div>
                </Grid>
              </Grid>
            </Box>
            {ismainTitleClrPalletOpen && (
              <div className="popoverpick" ref={mainTitileClrPopover}>
                {/* <CloseIcon
                    className="cursor-pointer picker-close"
                    onClick={() => mainTitleclrpalleteclose()}
                  /> */}
                <div
                  className="cursor-pointer picker-close"
                  onClick={() => mainTitleclrpalleteclose()}
                >
                  Close
                </div>
                <ChromePicker
                  color={textColor}
                  onChange={(color) => {
                    handleTextColorChange(color.hex);
                  }}
                />
              </div>
            )}
          </div>
        </Grid>
        {productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].technology != "rokuTv" && (
            <Grid item xs={12} sm={3}>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Font family</InputLabel>
                <OutlinedInput
                  type="text"
                  id={`font-family_${field}`}
                  value={fontFamily}
                  label="flow"
                  onChange={(e) => handleFontFamilyChange(e)}
                ></OutlinedInput>
                {/* <Select
              labelId="flow-select"
              id="flow-select"
              value={fontFamily}
              label="flow"
              onChange={(e) => handleFontFamilyChange(e)}
            >
              <MenuItem key={2} value={"Arial,sans-serif"}>
                {"Arial (sans-serif)"}
              </MenuItem>
              <MenuItem key={3} value={"Verdana,sans-serif"}>
                {"Verdana (sans-serif)"}
              </MenuItem>
              <MenuItem key={4} value={"Helvetica Neue,sans-serif"}>
                {"Helvetica (sans-serif)"}
              </MenuItem>
              <MenuItem key={5} value={"Tahoma,sans-serif"}>
                {"Tahoma (sans-serif)"}
              </MenuItem>
              <MenuItem key={6} value={"Trebuchet,sans-serif"}>
                {"Trebuchet (sans-serif)"}
              </MenuItem>
              <MenuItem key={13} value={"Andale Mono, sans-serif"}>
                {"Andale Mono (sans-serif)"}
              </MenuItem>

              <MenuItem key={12} value={"Monaco, sans-serif"}>
                {"Monaco (sans-serif)"}
              </MenuItem>

              <MenuItem key={14} value={"Open Sans"}>
                {"Open Sans (sans-serif)"}
              </MenuItem>
              <MenuItem key={15} value={"impact,sans-serif"}>
                {"Impact (sans-serif)"}
              </MenuItem>
              <MenuItem key={7} value={"Times New Roman,serif"}>
                {"Times New Roman (serif)"}
              </MenuItem>

              <MenuItem key={8} value={"Georgia,serif"}>
                {"Georgia (serif)"}
              </MenuItem>
              <MenuItem key={9} value={"Garamond,serif"}>
                {"Garamond (serif)"}
              </MenuItem>
              <MenuItem key={10} value={"Courier New,monospace"}>
                {"Courier New (monospace)"}
              </MenuItem>
              <MenuItem key={11} value={"Brush Script MT,cursive"}>
                {"Brush Script MT(cursive)"}
              </MenuItem>
            </Select> */}
              </FormControl>
            </Grid>
          )}
        {productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].technology != "rokuTv" && (
            <Grid item xs={12} sm={2}>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Font weight</InputLabel>
                <Select
                  name={`select_fontWeight`}
                  id={`font-weight_${field}`}
                  value={fontWeight}
                  onChange={(event) => {
                    handleFontWeight(event);
                  }}
                >
                  <MenuItem key={1} value={100}>
                    {100}
                  </MenuItem>
                  <MenuItem key={2} value={200}>
                    {200}
                  </MenuItem>
                  <MenuItem key={3} value={300}>
                    {300}
                  </MenuItem>
                  <MenuItem key={4} value={400}>
                    {400}
                  </MenuItem>
                  <MenuItem key={1} value={500}>
                    {500}
                  </MenuItem>
                  <MenuItem key={2} value={600}>
                    {600}
                  </MenuItem>
                  <MenuItem key={3} value={700}>
                    {700}
                  </MenuItem>
                  <MenuItem key={4} value={800}>
                    {800}
                  </MenuItem>
                  <MenuItem key={4} value={900}>
                    {900}
                  </MenuItem>
                  <MenuItem key={1} value={"initial"}>
                    {"initial"}
                  </MenuItem>
                  <MenuItem key={1} value={"lighter"}>
                    {"lighter"}
                  </MenuItem>
                  <MenuItem key={2} value={"normal"}>
                    {"normal"}
                  </MenuItem>
                  <MenuItem key={3} value={"bold"}>
                    {"bold"}
                  </MenuItem>
                  <MenuItem key={4} value={"bolder"}>
                    {"bolder"}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
        {productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].technology != "rokuTv" && (
            <Grid item xs={12} sm={2}>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Font Style </InputLabel>
                <Select
                  id={`font-style_${field}`}
                  name={`select_fontStyle`}
                  value={fontStyle}
                  onChange={(event) => {
                    handleFontStyle(event);
                  }}
                >
                  <MenuItem key={1} value={"normal"}>
                    {"normal"}
                  </MenuItem>
                  <MenuItem key={2} value={"italic"}>
                    {"italic"}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
        <Grid item xs={12} sm={2}>
          <FormControl className="custom-select" fullWidth>
            <InputLabel>Font Size </InputLabel>
            <Select
              id={`font-size_${field}`}
              name={`select_fontStyle`}
              value={
                productParams &&
                productParams.products &&
                productParams.products[0] &&
                productParams.products[0].technology != "rokuTv"
                  ? fontSize
                  : typeof fontSize == "string"
                  ? fontSize.replace("px", "")
                  : fontSize
              }
              onChange={(event) => {
                handleFontSize(event);
              }}
            >
              {productParams &&
              productParams.products &&
              productParams.products[0] &&
              productParams.products[0].technology != "rokuTv"
                ? Array.from(Array(field == "main-title" ? 60 : 35)).map(
                    (_, i) => (
                      <MenuItem key={`${i}`} value={`${i + 11}px`}>
                        {i + 11}px
                      </MenuItem>
                    )
                  )
                : Array.from(Array(field == "main-title" ? 60 : 35)).map(
                    (_, i) => (
                      <MenuItem key={`${i}`} value={`${i + 11}`}>
                        {i + 11}
                      </MenuItem>
                    )
                  )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      {/* *****************Form Appreance************************************** */}
    </>
  );
};

export default BrandingCommonForm;
